import { createSelector } from '@reduxjs/toolkit';
import { getControlUnitById } from '.';
import { mergeEventAndMetadata } from '../api/util/event/mergeEventAndMetadata';
import { RootState } from '../../store.model';
import ControlUnitAPI from '../api/ControlUnitAPI';
import { ControlUnitAPIResponse } from '../api/ControlUnit.model';

export const getControlUnitCurrentEventsById = createSelector(
  [
    (state: RootState) => state,
    (_: RootState, props: { deviceId: string; controlUnitId: string }) => props,
  ],
  (state, props) => {
    const { data } =
      ControlUnitAPI.endpoints.getCurrentEventsByCommanderID.select(
        props.deviceId
      )(state);
    return data?.[props.controlUnitId];
  }
);

export const getEventMetadataFromControlUnitState = (
  controlUnit?: ControlUnitAPIResponse,
  eventId?: string
) => {
  const metadata = controlUnit?.events.find((event) => event.id === eventId);
  return metadata;
};

export const getChannelMetadataFromControlUnitState = (
  controlUnit?: ControlUnitAPIResponse,
  channelId?: string
) => {
  const metadata = controlUnit?.channels.find(
    (channel) => channel.id === channelId
  );
  return metadata;
};

export const getMetadataControlUnitEventsFromId = createSelector(
  [getControlUnitById],
  (controlUnit) => controlUnit?.events
);
export const getMixedCurrentEventsFromId = createSelector(
  [getControlUnitCurrentEventsById, getMetadataControlUnitEventsFromId],
  mergeEventAndMetadata
);
